const noop = () => {};

export const getFedopsLoggerMock = () => ({
  interactionStarted: noop,
  interactionEnded: noop,
  appLoaded: noop,
});
